import React from 'react'

const AboutPage = () => (
  <div className="about-page section">
    <div className="columns is-multiline is-centered">
      <div className="column is-half">
        <img src="https://res.cloudinary.com/zackhave/image/upload/cindy-sherry/cindy_bw.jpg" className="about-image"/>
      </div>
      <div className="column is-half">
      <h1 className="title is-4">About Cindy</h1>
      <p>Cindy Sherry is an artist residing in Nelson, British Columbia. Her work, over three decades, has informed a unique artistic vision intent on capturing the fragility and beauty in the world and on challenging viewers to see and appreciate what we often take for granted.</p>
      <p>Sherry’s art has been described as ‘uplifting and playful in voice, asking the viewer to discover layered views of interpretation. It can evoke happiness or it can demonstrate a satirical opinion while considering humanity’s compromising place in nature.’</p>
      <p>The galleries on this site contain paintings from two series; ‘Garden Gnomes’ and ‘At One With Nature’. Both bodies of work address themes in the artist’s loose, energetic, colourful style.</p>
      <p>Sherry earned her B.F.A. from Queen’s University in Kingston, Ontario, where she was a finalist in the RBC Bank’s ‘Art Venture’ competition. Her paintings and drawings have been exhibited in Quebec, Ontario, and British Columbia. They have a place with collections in Canada, England, The United States, and Japan.</p>
      </div>
      <div className="column is-one-third">
      <a href="/#gallery-1">
      <img src="https://res.cloudinary.com/zackhave/image/upload/cindy-sherry/Cindy_s_art_-_30x40_-_Just_the_Bee_s_Knees_-_FX87902.jpg" />
      </a>
      </div>
      <div className="column is-one-third">
      <a href="/#gallery-2">
      <img src="https://res.cloudinary.com/zackhave/image/upload/cindy-sherry/Cindy_s_art_-_30x40_-_Tossing_Rocks_-_FX87905.jpg" />
      </a>
      </div>
    </div>
  </div>
)

export default AboutPage



// WEBPACK FOOTER //
// ./src/pages/about.js